export default class MonthlyBreakdown {
    _monthlyRent = 0.0
    _hoa = 0
    _insurance = 0
    _taxes = 0
    _mortgagePayment = 0
    _maintenance = 0
    _profitExclMortgage = 0

    set profitExclMortgage(value) {
        this._profitExclMortgage = Math.round(value);
    }

    get profitExclMortgage() {
        return this._profitExclMortgage;
    }

    set maintenance(value) {
        this._maintenance = Math.round(value);
    }

    get maintenance() {
        return this._maintenance;
    }

    set mortgagePayment(value) {
        this._mortgagePayment = Math.round(value);
    }

    get mortgagePayment() {
        return this._mortgagePayment;
    }

    set taxes(value) {
        this._taxes = Math.round(value);
    }

    get taxes() {
        return this._taxes;
    }

    set insurance(value) {
        this._insurance = Math.round(value);
    }

    get insurance() {
        return this._insurance;
    } 

    set hoa(value) {
        this._hoa = Math.round(value);
    }

    get hoa() {
        return this._hoa;
    }

    set monthlyRent(value) {
        this._monthlyRent = value;
    }

    get monthlyRent() {
        return this._monthlyRent;
    }

    get totalExpenses() {
        return this.hoa + this.insurance + this.maintenance + this.mortgagePayment + this.taxes;
    }
}